import L from "leaflet";

const SHAPE_LABEL_MARGIN_PX = 40;

type ShapeLayer = L.Circle | L.Polygon | L.Rectangle;

export const positionShapeTooltip = (
  layer: ShapeLayer,
  alignment: string,
  map: L.Map
) => {
  if (!["top", "bottom"].includes(alignment)) {
    return;
  }

  const tooltip = layer.getTooltip();

  if (!tooltip) {
    return;
  }

  const bounds = layer.getBounds();
  const centerPoint = map.latLngToLayerPoint(bounds.getCenter());
  const northPoint = map.latLngToLayerPoint(bounds.getNorthWest());
  const southPoint = map.latLngToLayerPoint(bounds.getSouthWest());

  const targetPoint = centerPoint.clone();
  const boundsHeight = Math.abs(northPoint.y - southPoint.y);
  const proportionalMargin = boundsHeight * 0.2;
  const dynamicMargin = Math.min(SHAPE_LABEL_MARGIN_PX, proportionalMargin);

  if (alignment === "top") {
    targetPoint.y = centerPoint.y - dynamicMargin;
  } else if (alignment === "bottom") {
    targetPoint.y = centerPoint.y + dynamicMargin;
  }

  const targetLatLng = map.layerPointToLatLng(targetPoint);

  tooltip.setLatLng(targetLatLng);
};
